import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { PartnerTooltip } from '../../PartnerTooltip';
import { IAgentCard, IAgentCardParticipation } from '../../../types/agentCard';
import { ApprovalContainerNew } from '../../../containers/ApprovalContainer/ApprovalContainerNew';
import { Participation } from '../../Participation';

import * as styles from './AboutRealtorDesktop.css';

export interface INameProps {
  name: IAgentCard['name'];
  isCianPartner?: boolean;
  participations: IAgentCardParticipation[];
}

export const Name = ({ name, isCianPartner, participations }: INameProps) => {
  return (
    <div className={styles['name-container']}>
      <div className={styles['title']}>
        <span className={styles['agent-name']} data-name="RealtorName">
          <UIHeading1>{name}</UIHeading1>
          {isCianPartner && <PartnerTooltip />}
        </span>

        <div className={styles['credentials']}>
          {participations.map(item => (
            <Participation key={item.type} participation={item} />
          ))}
          <ApprovalContainerNew />
        </div>
      </div>
    </div>
  );
};
